import React, { useState } from "react";
import { changePassword } from "../api/authApi";
import { useToast } from "../context/ToastContext";
import logo from "../assets/nuri-logo.png";

const Layout = ({ children, menuItems = [], onLogout }) => {
  const showToast = useToast();
  const [showPwModal, setShowPwModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const closePwModal = () => {
    setShowPwModal(false);
    setCurrentPassword("");
    setNewPassword("");
    setNewPasswordConfirm("");
  };

  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !newPasswordConfirm) {
      showToast("모든 항목을 입력해주세요.");
      return;
    }
    if (newPassword !== newPasswordConfirm) {
      showToast("새 비밀번호가 일치하지 않습니다.");
      return;
    }
    try {
      await changePassword(currentPassword, newPassword);
      showToast("비밀번호가 변경되었습니다.");
      closePwModal();
    } catch (err) {
      showToast(err.message);
    }
  };

  return (
    <div className="layout">
      <header className="layout-header no-print">
        <div className="layout-header-left">
          <span
            onClick={() => setShowPwModal(true)}
            style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
            title="클릭하면 비밀번호를 변경할 수 있습니다."
          >
            <img src={logo} alt="누리도시락" className="app-logo" />
            <h1>누리도시락</h1>
          </span>
          <nav className="layout-nav-inline">
            {menuItems.map((item) => (
              <a key={item.path} href={item.path}>
                {item.label}
              </a>
            ))}
          </nav>
        </div>
        <button onClick={onLogout}>로그아웃</button>
      </header>
      <main className="layout-main">{children}</main>

      {showPwModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>비밀번호 변경</h2>
            <input
              type="password"
              placeholder="현재 비밀번호"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="새 비밀번호"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="새 비밀번호 확인"
              value={newPasswordConfirm}
              onChange={(e) => setNewPasswordConfirm(e.target.value)}
            />
            <div className="form-actions">
              <button className="btn-primary" onClick={handleChangePassword}>변경</button>
              <button onClick={closePwModal}>취소</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;